import { render } from "./MessageHouseHome.vue?vue&type=template&id=f38a0dee&scoped=true"
import script from "./MessageHouseHome.vue?vue&type=script&lang=js"
export * from "./MessageHouseHome.vue?vue&type=script&lang=js"

import "./MessageHouseHome.vue?vue&type=style&index=0&id=f38a0dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38a0dee"]])

export default __exports__